import { render, staticRenderFns } from "./BsCardFooter.vue?vue&type=template&id=1d6aafa5&scoped=true&"
import script from "./BsCardFooter.vue?vue&type=script&lang=js&"
export * from "./BsCardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6aafa5",
  null
  
)

export default component.exports